import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

type Level = 'debug' | 'info' | 'warn' | 'error';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private log(level: Level, tag: string, message: string, extra?: unknown): void {
    if (!environment.production) {
      const consoleFn = level === 'debug' ? console.log : console[level];
      consoleFn(`[${tag}]`, message, extra ?? '');
    }

    if (level === 'debug') return;

    Sentry.addBreadcrumb({
      category: tag,
      message,
      level: level === 'warn' ? 'warning' : level,
      data: extra && typeof extra === 'object' ? (extra as Record<string, unknown>) : undefined,
    });
  }

  debug(tag: string, message: string, extra?: unknown): void {
    this.log('debug', tag, message, extra);
  }

  info(tag: string, message: string, extra?: unknown): void {
    this.log('info', tag, message, extra);
  }

  warn(tag: string, message: string, extra?: unknown): void {
    this.log('warn', tag, message, extra);
  }

  error(tag: string, message: string, err?: unknown): void {
    this.log('error', tag, message, err);

    if (err instanceof Error) {
      Sentry.captureException(err);
    } else if (err !== undefined) {
      Sentry.captureMessage(`${tag}: ${message}`, { extra: { err } });
    } else {
      Sentry.captureMessage(`${tag}: ${message}`);
    }
  }
}
